import { css } from '@emotion/css'
import { fontSize, fontWeight, spacing, colors } from '@offerzen/pinata-shame'

const styles = {
  heading: css({
    fontSize: fontSize.medium,
    fontWeight: fontWeight.bold,
    marginBottom: spacing.medium,
    color: colors.blackPearl,
  }),

  markdown: css({
    'p, li': {
      color: colors.scorpion,
    },
  }),
}

export default styles
